
import Vue, { PropType } from 'vue';
import { CvProgress, CvProgressStep } from '@carbon/vue';
import { FlowStep } from '../../typings/index';

export default Vue.extend({
  components: { CvProgress, CvProgressStep },
  props: {
    steps: {
      type: [] as PropType<FlowStep[]>,
      required: true,
    },
    showProgressIndicator: {
      type: Boolean,
      required: true,
    },
  },
});
